require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-5-trends-2019-marketing-plan.json") })
        }
      }, "path---tapd-in-5-trends-2019-marketing-plan");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-5-trends-2019-marketing-plan!./.cache/json/tapd-in-5-trends-2019-marketing-plan.json
// module id = 801
// module chunks = 231608221292675